import React, { useContext } from 'react';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import searchImage from './media/search.png';
import { getNoDataWarningStyles } from './style/no-recommendation-warning-style';

export const NoRecommendationWarning = () => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getNoDataWarningStyles);
  return (
    <div className={classNames(classes.root, 'no-recommendation')}>
      <div className={classes.imageContainer}>
        <img src={searchImage} alt={i18n.getString(_TL_('colorful search icon'))} className={classes.image} />
      </div>
      <div className={classes.keyHint}>
        {i18n.getString(_TL_('No keywords found'))}
      </div>
      <div className={classes.description}>
        {i18n.getString(_TL_('We were unable to suggest any keywords based on the URL provided. Please try entering a different URL, product, or service.'))}
      </div>
    </div>
  );
};
